<script setup lang="ts">
const { toasts, queuedCount, remove } = useToast();
</script>

<template>
  <div
    class="fixed bottom-6 left-0 z-[9999] w-full px-4 sm:left-auto sm:right-6 sm:max-w-[400px] sm:px-0"
  >
    <TransitionGroup
      name="toast"
      tag="div"
      class="flex w-full flex-col gap-2.5"
    >
      <Toast v-for="t in toasts" :key="t.id" :toast="t" @close="remove" />
    </TransitionGroup>

    <div
      v-if="queuedCount > 0"
      class="mt-2 text-right text-xs text-slate-400 opacity-75"
    >
      {{ $t("toast.more", { count: queuedCount }) }}
    </div>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition:
    transform 180ms ease,
    opacity 180ms ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(10px) scale(0.98);
}

.toast-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.toast-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.toast-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(0.98);
}
</style>
